export default "__VITE_ASSET__CVT0Elat__"